// Maritime crew statistics cards - 4 cards matching Figma layout
import React from 'react';
import { Users, Ship, Calendar, Stethoscope } from 'lucide-react';

const statCardConfig = [
  {
    key: 'total',
    label: 'Total Crew',
    icon: Users,
    iconStyle: { color: '#2563eb', backgroundColor: '#dbeafe' }, // blue-600, blue-50
    getValue: (props) => props.totalCount,
    getSubtitle: (props) => {
      const diff = props.totalCount - (props.prevTotalCount || props.totalCount);
      if (diff > 0) return `+${diff} this month`;
      return 'All members';
    },
  },
  {
    key: 'onboard',
    label: 'Currently Onboard',
    icon: Ship,
    iconStyle: { color: '#059669', backgroundColor: '#d1fae5' }, // emerald-600, emerald-50
    getValue: (props) => props.activeCount,
    getSubtitle: (props) => {
      if (!props.activeCount) return 'No active crew';
      if (props.deptCount) return `Across ${props.deptCount} department${props.deptCount !== 1 ? 's' : ''}`;
      return 'Active members';
    },
  },
  {
    key: 'onLeave',
    label: 'On Leave',
    icon: Calendar,
    iconStyle: { color: '#ea580c', backgroundColor: '#ffedd5' }, // orange-600, orange-50
    getValue: (props) => props.bouncedCount,
    getSubtitle: (props) => {
      if (!props.bouncedCount) return 'All on duty';
      return 'Review schedule';
    },
  },
  {
    key: 'medical',
    label: 'Medical Alerts',
    icon: Stethoscope,
    iconStyle: { color: '#dc2626', backgroundColor: '#fef2f2' }, // red-600, red-50
    // TODO: wire up real medical alerts API — currently no backend endpoint
    getValue: () => 0,
    getSubtitle: (_, value) => value > 0 ? 'Requires attention' : 'No issues',
  },
];

const CrewStatCards = ({ totalCount, activeCount, bouncedCount, deptCount }) => {
  const props = { totalCount, activeCount, bouncedCount, deptCount };

  return (
    <div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-4 tw-gap-4">
      {statCardConfig.map((card) => {
        const IconComponent = card.icon;
        const value = card.getValue(props);
        return (
          <div
            key={card.key}
            className="tw-bg-white tw-border tw-border-gray-200 tw-rounded-xl tw-p-4 tw-flex tw-items-start tw-justify-between tw-shadow-sm"
          >
            {/* Left: text content */}
            <div>
              <p className="tw-text-sm tw-font-medium tw-text-gray-500 tw-m-0">
                {card.label}
              </p>
              <h3 className="tw-text-2xl tw-font-bold tw-mt-1 tw-m-0">
                {value}
              </h3>
              <p className="tw-text-xs tw-text-gray-400 tw-mt-1 tw-m-0">
                {card.getSubtitle(props, value)}
              </p>
            </div>

            {/* Right: icon with colored background */}
            <div
              style={{ padding: '8px', borderRadius: '8px', ...card.iconStyle }}
              aria-hidden="true"
            >
              <IconComponent style={{ width: '20px', height: '20px' }} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CrewStatCards;
